import React, { useEffect } from 'react';

interface UseKeepSizeAfterRenderOptions {
  keepWidth?: boolean;
  keepHeight?: boolean;
}

export const useKeepSizeAfterRender = (
  buttonRef: React.RefObject<HTMLElement>,
  { keepWidth, keepHeight }: UseKeepSizeAfterRenderOptions,
  resizeTrigger?: unknown,
) => {
  useEffect(() => {
    const element = buttonRef.current;
    if (!element) {
      return;
    }
    const { width, height } = element.getBoundingClientRect();
    if (keepWidth) {
      element.style.width = `${width}px`;
    }
    if (keepHeight) {
      element.style.height = `${height}px`;
    }
  }, [buttonRef, keepWidth, keepHeight, resizeTrigger]);
};
